import { Component, OnInit } from '@angular/core';
import { ROUTE_ANIMATIONS_ELEMENTS, NotificationService } from '@cradua/core';
import { TitleDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-title-container',
  templateUrl: './title-container.component.html',
  styleUrls: ['./title-container.component.scss']
})
export class TitleContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  titles$: Observable<TitleDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Title");
    this.titles$ = this.gatwayFacade.loadGateway("Title");
    this.titles$.subscribe(data => {
      console.log("data: cont. yufufy",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteTitle(deletedValue: any) {
    this.gatwayFacade.remove("Title", deletedValue);
    // this.store.dispatch(TitleStoreActions.removeTitle({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitTitle(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Titles = formValue.Titles.reverse();
    event.preventDefault();
    const pullData = formValue.Titles;
    //const newPullData = formValue.Titlees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllTitle = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllTitle.push(pullData[i]);
    }
  }

// check if the addAllTitle array is not empty, then dispatch the data to the store
   if(addAllTitle.length !== 0) {
    this.gatwayFacade.add('Title', addAllTitle);
    // this.store.dispatch(TitleStoreActions.addTitle({newTitle: addAllTitle}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Title', allUpdates, ['id']);
    // this.store.dispatch(TitleStoreActions.updateTitle({updateTitle: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }

}
